import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getToken } from '../../utils/token';

export const panApi = createApi({
  reducerPath: 'panApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL+"/api",
    prepareHeaders: (headers) => {
      const token = getToken();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    panLookupApi: builder.mutation({
      query: (credentials) => ({
        url: `/panlookup`,
        method: 'POST',
        body: credentials,
      }),
    }),
  }),
});

export const { usePanLookupApiMutation } = panApi;
